import { render, staticRenderFns } from "./DiscountCap.vue?vue&type=template&id=6b9ed7d1&"
import script from "./DiscountCap.vue?vue&type=script&lang=ts&"
export * from "./DiscountCap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports